import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpRedisburseBatchPrintPage } from '@/features/pcmp/pages/PcmpRedisburseBatchPrintPage';
import { pcmpRedisburseBatchPrintSearchSchema } from '@/features/pcmp/types/pcmpAccounts.types';

export const Route = createFileRoute('/_print/pcmp/accounts/redisburse-batches/$batchNo/print')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  validateSearch: pcmpRedisburseBatchPrintSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Re-Disbursement Batch Report">
      <PcmpRedisburseBatchPrintPage />
    </ErrorBoundary>
  ),
});
